<div class="registration_type">
  <h2 class="registration_type__question">{{"PAGES.AUTH.REGISTRATION.REGISTRATION_TYPE.QUESTION" | translate}}</h2>
  <p class="registration_type__info">{{"PAGES.AUTH.REGISTRATION.REGISTRATION_TYPE.QUESTION.INFO" | translate}}</p>
  
  <div class="registration_type__question__options">
    <button
      mm-button
      class="registration_type__have_card"
      color="primary"
      (click)="onHaveCardClick()"
    >
      {{"PAGES.AUTH.REGISTRATION.REGISTRATION_TYPE.QUESTION.HAVE_CARD" | translate}}
    </button>
    <button
      mm-button
      class="registration_type__no_card"
      color="primary"
      (click)="onNoCardClick()"
      test-target="registration_type__no_card"
    >
      {{"PAGES.AUTH.REGISTRATION.REGISTRATION_TYPE.QUESTION.NO_CARD" | translate}}
    </button>
  </div>
</div>
